export const NUMBER_FORMAT = 'YYYY-M-DD';
export const FULL_MONTH_DATE = 'MMM D, YYYY';
export const HOUR_MIN = 'HH:mm';
export const HOUR_MIN_A = 'hh:mm a';

export const MONTH_DAY_YEAR = 'MM/DD/YYYY';
export const LOCAL_TIME = 'LT';
export const MONTH_DAY_MMM_D = 'mmm dd';
